import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'kit-general-27',
  templateUrl: './27.component.html',
  styleUrls: ['./27.component.scss'],
})
export class CuiGeneral27Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
